export var euiBreakpoints = {"xs":0,"s":575,"m":768,"l":992,"xl":1200}
export var euiBreakpointKeys = ["xs","s","m","l","xl"]
export default {"euiBreakpoints":{"xs":0,"s":575,"m":768,"l":992,"xl":1200},"euiBreakpointKeys":["xs","s","m","l","xl"]}
